<template>
  <div class="min-h-screen bg-white dark:bg-[#0c1427] p-3" :dir="isRtl ? 'rtl' : 'ltr'">
    <div class="max-w-6xl mx-auto">
      <!-- Page Header -->
      <div class="mb-4">
        <div
          class="relative rounded-2xl p-3 shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden w-full"
          style="
            background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);
            box-shadow: 0 8px 32px rgba(88, 86, 214, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.2);
          "
        >
          <!-- Background decorative elements -->
          <div class="absolute inset-0 overflow-hidden">
            <div
              class="absolute -top-20 -right-20 w-40 h-40 rounded-full opacity-20"
              style="
                background: radial-gradient(
                  circle,
                  rgba(255, 255, 255, 0.3) 0%,
                  transparent 70%
                );
              "
            ></div>
            <div
              class="absolute -bottom-16 -left-16 w-32 h-32 rounded-full opacity-15"
              style="
                background: radial-gradient(
                  circle,
                  rgba(255, 255, 255, 0.4) 0%,
                  transparent 70%
                );
              "
            ></div>
            </div>
          
          <!-- Header content -->
          <div class="relative z-10">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-4">
                <div class="relative flex-shrink-0">
                  <div class="w-20 h-20 rounded-full bg-white/20 backdrop-blur-sm border-3 border-white/70 shadow-xl flex items-center justify-center">
                    <i class="material-symbols-outlined text-white text-3xl">inventory_2</i>
          </div>
            </div>
                
                <div>
                  <h1 class="text-2xl font-bold text-white drop-shadow-sm mb-1">
                    {{ directT('ecommerce.createProduct.addProduct') }}
                  </h1>
                  <p class="text-white/80 text-sm font-medium">
                    {{ directT('ecommerce.createProduct.subtitle') || 'צור מוצר חדש במערכת' }}
                  </p>
            </div>
              </div>
              

            </div>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <form>
        <div class="lg:grid lg:grid-cols-3 gap-6">
          <div class="lg:col-span-2">
            <div class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">info</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                  {{ directT('ecommerce.createProduct.productInformation') || 'מידע מוצר' }}
                </h3>
              </div>
              <div v-if="error" class="p-4 bg-red-50/80 dark:bg-red-900/20 backdrop-blur-xl rounded-2xl shadow-lg border border-red-200/50 dark:border-red-800/30 mb-6">
                <div class="flex items-start gap-4">
                  <div class="w-10 h-10 bg-red-500/10 rounded-xl flex items-center justify-center">
                    <i class="material-symbols-outlined text-red-500 text-xl">error</i>
                  </div>
                  <div>
                    <h3 class="text-lg font-semibold text-red-700 dark:text-red-400">שגיאה</h3>
                    <p class="text-red-600 dark:text-red-300 mt-1">{{ error }}</p>
                  </div>
                </div>
              </div>
              
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Product Title -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">title</i>
                  {{ directT('ecommerce.createProduct.productTitle') }}
                    <span class="text-red-500">*</span>
                </label>
                  <div class="relative">
                <input
                  type="text"
                  v-model="product.title"
                      :placeholder="directT('ecommerce.createProduct.productTitlePlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">edit</i>
              </div>
                  </div>
                </div>
                <!-- Product Type -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">category</i>
                  {{ directT('ecommerce.createProduct.productType') }}
                </label>
                  <div class="relative">
                <select
                  v-model="product.product_type"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white cursor-pointer appearance-none"
                >
                  <option value="">{{ directT('ecommerce.createProduct.selectType') }}</option>
                  <option value="Digital Product">{{ directT('ecommerce.createProduct.digitalProduct') }}</option>
                  <option value="Physical Product">{{ directT('ecommerce.createProduct.physicalProduct') }}</option>
                  <option value="Service">{{ directT('ecommerce.createProduct.service') }}</option>
                </select>
                    <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                      <i class="material-symbols-outlined text-gray-400 text-sm">expand_more</i>
              </div>
                  </div>
                </div>
                <!-- Category -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">label</i>
                  {{ directT('ecommerce.createProduct.category') }}
                </label>
                  <div class="relative">
                <input
                  type="text"
                  v-model="product.category"
                      :placeholder="directT('ecommerce.createProduct.categoryPlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">edit</i>
              </div>
                  </div>
                </div>
                
                <!-- Stock Amount -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">inventory</i>
                    {{ directT('ecommerce.createProduct.stockAmount') }}
                  </label>
                  <div class="relative">
                    <input
                      type="number"
                      v-model="product.stock_amount"
                      :placeholder="directT('ecommerce.createProduct.stockAmountPlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">inventory_2</i>
                    </div>
                  </div>
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-2 flex items-center gap-1">
                    <i class="material-symbols-outlined text-xs">info</i>
                    {{ directT('ecommerce.createProduct.stockAmountHint') }}
                  </p>
                </div>
                
                <!-- Description -->
                <div class="md:col-span-2 group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">description</i>
                  {{ directT('ecommerce.createProduct.description') }}
                </label>
                  <div class="relative">
                <textarea
                  v-model="product.description"
                      rows="4"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 resize-none"
                      :placeholder="directT('ecommerce.createProduct.descriptionPlaceholder') || 'תיאור המוצר...'"
                ></textarea>
                    <div class="absolute right-3 top-3">
                      <i class="material-symbols-outlined text-gray-400 text-sm">edit</i>
              </div>
                  </div>
                </div>
                <!-- Regular Price -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">payments</i>
                  {{ directT('ecommerce.createProduct.regularPrice') }}
                </label>
                  <div class="relative">
                <input
                  type="text"
                  v-model="product.price"
                      :placeholder="directT('ecommerce.createProduct.regularPricePlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">attach_money</i>
              </div>
                  </div>
                </div>
                
                <!-- Sale Price -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">local_offer</i>
                  {{ directT('ecommerce.createProduct.salePrice') }}
                </label>
                  <div class="relative">
                <input
                  type="text"
                  v-model="product.compare_at_price"
                      :placeholder="directT('ecommerce.createProduct.salePricePlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">sell</i>
              </div>
                  </div>
                </div>
                <!-- Product Link -->
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">link</i>
                  {{ directT('ecommerce.createProduct.productLink') }}
                </label>
                  <div class="relative">
                <input
                  type="text"
                  v-model="product.product_link"
                      :placeholder="directT('ecommerce.createProduct.productLinkPlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">open_in_new</i>
              </div>
                  </div>
                </div>
                

                <!-- Product Image -->
                <div class="md:col-span-2 group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">image</i>
                  {{ directT('ecommerce.createProduct.productImage') }}
                </label>
                  
                  <div class="flex items-start gap-6">
                    <!-- Image Preview -->
                    <div v-if="product.image_link" class="flex-shrink-0">
                      <div class="w-32 h-32 rounded-2xl overflow-hidden shadow-lg border-2 border-gray-200 dark:border-gray-600">
                    <img :src="product.image_link" alt="Product image" class="w-full h-full object-cover" />
                  </div>
                        </div>
                    
                    <!-- Upload Area -->
                    <div class="flex-1">
                      <div class="relative">
                        <div class="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-2xl p-8 text-center hover:border-purple-400 dark:hover:border-purple-500 transition-colors duration-200 bg-gray-50/50 dark:bg-gray-800/50 backdrop-blur-sm">
                          <div class="flex flex-col items-center gap-4">
                            <div class="w-16 h-16 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-2xl flex items-center justify-center shadow-lg">
                              <i class="material-symbols-outlined text-white text-2xl">cloud_upload</i>
                            </div>
                            <div>
                              <p class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
                                {{ directT('ecommerce.createProduct.clickToUpload') }}
                              </p>
                              <p class="text-sm text-gray-500 dark:text-gray-400">
                                {{ directT('ecommerce.createProduct.image') || 'PNG, JPG, GIF עד 10MB' }}
                              </p>
                            </div>
                      </div>
                      <input
                        type="file"
                        id="fileInput"
                            class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        @change="handleFileUpload"
                        accept="image/*"
                      />
                    </div>
                  </div>
                      
                      <!-- Upload Status -->
                      <div v-if="uploadStatus" class="mt-4 flex items-center gap-2">
                        <div v-if="uploadStatus === 'uploading'" class="flex items-center gap-2 text-blue-600 dark:text-blue-400">
                          <div class="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                          <span class="text-sm font-medium">{{ directT('ecommerce.createProduct.uploading') }}</span>
                  </div>
                        <div v-else-if="uploadStatus === 'success'" class="flex items-center gap-2 text-green-600 dark:text-green-400">
                          <i class="material-symbols-outlined text-sm">check_circle</i>
                          <span class="text-sm font-medium">{{ directT('ecommerce.createProduct.uploadSuccess') }}</span>
                </div>
                        <div v-else-if="uploadStatus === 'error'" class="flex items-center gap-2 text-red-600 dark:text-red-400">
                          <i class="material-symbols-outlined text-sm">error</i>
                          <span class="text-sm font-medium">{{ directT('ecommerce.createProduct.uploadFailed') }}</span>
              </div>
            </div>
          </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Product Variations Card -->
            <div v-if="showVariations" class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
              <div class="flex items-center justify-between mb-6">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                    <i class="material-symbols-outlined text-white text-lg">tune</i>
                  </div>
                  <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                    {{ directT('ecommerce.createProduct.productVariations') }}
                  </h3>
                </div>
                
                <!-- Delete Variations Card Button -->
            <button 
              type="button" 
                  @click="removeVariationsCard"
                  class="flex items-center gap-2 px-3 py-2 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 border border-red-200 dark:border-red-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                  :title="directT('ecommerce.createProduct.removeVariationsCard')"
            >
                  <i class="material-symbols-outlined text-red-600 dark:text-red-400 text-sm group-hover:scale-110 transition-transform">delete</i>
                  <span class="text-xs font-medium text-red-700 dark:text-red-300">
                    {{ directT('ecommerce.createProduct.removeCard') }}
                  </span>
            </button>
          </div>
              
              <!-- Variation Groups -->
              <div class="space-y-8">
                <div v-for="(group, groupIndex) in variationGroups" :key="groupIndex" class="border-2 border-gray-200 dark:border-gray-600 rounded-2xl p-6 bg-gradient-to-br from-gray-50/50 to-white dark:from-gray-800/50 dark:to-gray-900/50">
                  <!-- Group Header -->
                  <div class="flex items-center justify-between mb-6">
                    <div class="flex items-center gap-3">
                      <div class="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center">
                        <i class="material-symbols-outlined text-white text-sm">category</i>
        </div>
                      <h4 class="text-md font-semibold text-gray-800 dark:text-gray-200">
                        {{ directT('ecommerce.createProduct.variationGroup') }} {{ groupIndex + 1 }}
                      </h4>
      </div>
                    
                    <!-- Remove Group Button -->
                    <button
                      type="button"
                      @click="removeVariationGroup(groupIndex)"
                      class="flex items-center gap-1 px-2 py-1 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 border border-red-200 dark:border-red-700/50 rounded-lg transition-all duration-200 group"
                      :title="directT('ecommerce.createProduct.removeVariationGroup')"
                    >
                      <i class="material-symbols-outlined text-red-600 dark:text-red-400 text-xs group-hover:scale-110 transition-transform">close</i>
                    </button>
                  </div>
                  
                  <!-- Variation Group Name -->
                  <div class="group mb-6">
                    <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                      <i class="material-symbols-outlined text-purple-600 text-sm">label</i>
                      {{ directT('ecommerce.createProduct.variationName') }}
                    </label>
                    <div class="relative">
                      <input
                        type="text"
                        v-model="group.name"
                        :placeholder="directT('ecommerce.createProduct.variationNamePlaceholder')"
                        class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                      />
                      <div class="absolute right-3 top-1/2 -translate-y-1/2">
                        <i class="material-symbols-outlined text-gray-400 text-sm">edit</i>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Variation Rows -->
                  <div class="space-y-4">
                    <div v-for="(row, rowIndex) in group.rows" :key="rowIndex" class="border border-gray-200 dark:border-gray-600 rounded-xl p-4 bg-white/70 dark:bg-gray-800/70">
                      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <!-- Variation Text -->
                        <div class="group">
                          <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                            <i class="material-symbols-outlined text-purple-600 text-sm">text_fields</i>
                            {{ directT('ecommerce.createProduct.variation') }}
                          </label>
                          <div class="relative">
                            <input
                              type="text"
                              v-model="row.text"
                              :placeholder="directT('ecommerce.createProduct.variationPlaceholder')"
                              class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                            />
                            <div class="absolute right-3 top-1/2 -translate-y-1/2">
                              <i class="material-symbols-outlined text-gray-400 text-sm">edit</i>
                            </div>
                          </div>
                        </div>
                        
                        <!-- Variation Price -->
                        <div class="group">
                          <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                            <i class="material-symbols-outlined text-purple-600 text-sm">attach_money</i>
                            {{ directT('ecommerce.createProduct.price') }}
                          </label>
                          <div class="relative">
                            <input
                              type="number"
                              step="0.01"
                              v-model="row.price"
                              :placeholder="directT('ecommerce.createProduct.pricePlaceholder')"
                              class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                            />
                            <div class="absolute right-3 top-1/2 -translate-y-1/2">
                              <i class="material-symbols-outlined text-gray-400 text-sm">attach_money</i>
                            </div>
                          </div>
                        </div>
                        
                        <!-- Variation Compare At Price -->
                        <div class="group">
                          <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                            <i class="material-symbols-outlined text-purple-600 text-sm">local_offer</i>
                            {{ directT('ecommerce.createProduct.compareAtPrice') }}
                          </label>
                          <div class="relative">
                            <input
                              type="number"
                              step="0.01"
                              v-model="row.compare_at_price"
                              :placeholder="directT('ecommerce.createProduct.compareAtPricePlaceholder')"
                              class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                            />
                            <div class="absolute right-3 top-1/2 -translate-y-1/2">
                              <i class="material-symbols-outlined text-gray-400 text-sm">local_offer</i>
                            </div>
                          </div>
                        </div>
                        
                        <!-- Variation Image -->
                        <div class="group">
                          <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                            <i class="material-symbols-outlined text-purple-600 text-sm">image</i>
                            {{ directT('ecommerce.createProduct.variationImage') }}
                          </label>
                          
                          <div class="flex items-center gap-3">
                            <!-- Image Preview -->
                            <div v-if="row.image" class="flex-shrink-0">
                              <div class="w-16 h-16 rounded-xl overflow-hidden shadow-lg border-2 border-gray-200 dark:border-gray-600">
                                <img :src="row.image" alt="Variation image" class="w-full h-full object-cover" />
                              </div>
                            </div>
                            
                            <!-- Upload Button -->
                            <div class="flex-1">
                              <div class="relative">
                                <div class="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-3 text-center hover:border-purple-400 dark:hover:border-purple-500 transition-colors duration-200 bg-white dark:bg-gray-800">
                                  <div class="flex items-center justify-center gap-2">
                                    <div class="w-8 h-8 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-lg flex items-center justify-center">
                                      <i class="material-symbols-outlined text-white text-sm">cloud_upload</i>
                                    </div>
                                    <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
                                      {{ directT('ecommerce.createProduct.uploadImage') }}
                                    </span>
                                  </div>
                                  <input
                                    type="file"
                                    class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                    @change="handleVariationImageUpload($event, groupIndex, rowIndex)"
                                    accept="image/*"
                                  />
                                </div>
                              </div>
                            </div>
                            
                            <!-- Remove Row Button -->
                            <button
                              v-if="group.rows.length > 1"
                              type="button"
                              @click="removeVariationRow(groupIndex, rowIndex)"
                              class="flex-shrink-0 w-10 h-10 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 border border-red-200 dark:border-red-700/50 rounded-xl flex items-center justify-center transition-colors duration-200 group"
                            >
                              <i class="material-symbols-outlined text-red-600 dark:text-red-400 text-sm group-hover:scale-110 transition-transform">delete</i>
                            </button>
            </div>
          </div>
                      </div>
                    </div>
                    
                    <!-- Add Row Button -->
                    <button
                      type="button"
                      @click="addVariationRow(groupIndex)"
                      class="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 hover:from-blue-100 hover:to-indigo-100 dark:hover:from-blue-900/30 dark:hover:to-indigo-900/30 border-2 border-dashed border-blue-200 dark:border-blue-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                    >
                      <div class="w-6 h-6 bg-blue-500/10 dark:bg-blue-400/20 rounded-lg flex items-center justify-center group-hover:bg-blue-500/20 dark:group-hover:bg-blue-400/30 transition-colors">
                        <i class="material-symbols-outlined text-blue-600 dark:text-blue-400 text-sm">add</i>
                      </div>
                      <span class="text-sm font-medium text-blue-700 dark:text-blue-300">
                        {{ directT('ecommerce.createProduct.addVariationRow') }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Custom Fields Card -->
            <div v-if="showCustomFields" class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mb-6">
              <!-- Header -->
              <div class="flex items-center justify-between mb-6">
                <div class="flex items-center gap-3">
                  <div class="w-10 h-10 rounded-xl flex items-center justify-center" style="background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);">
                    <i class="material-symbols-outlined text-white text-lg">add_box</i>
                  </div>
                  <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                    {{ directT('ecommerce.createProduct.customFields') }}
                  </h3>
                </div>
                <button
                  @click="removeCustomFieldsCard"
                  class="w-10 h-10 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 border border-red-200 dark:border-red-700/50 rounded-xl flex items-center justify-center transition-colors duration-200 group"
                >
                  <i class="material-symbols-outlined text-red-600 dark:text-red-400 text-sm group-hover:scale-110 transition-transform">delete</i>
                </button>
              </div>

              <!-- Field Group Name -->
              <div class="mb-6">
                <label class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">
                  {{ directT('ecommerce.createProduct.fieldGroupName') }}
                </label>
                <input
                  v-model="editingCustomField.name"
                  type="text"
                  :placeholder="directT('ecommerce.createProduct.fieldGroupNamePlaceholder')"
                  class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-green-500/20 focus:border-green-500 text-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                />
              </div>

              <!-- Field Types Grid -->
              <div v-if="!selectedFieldType" class="mb-6">
                <h4 class="text-sm font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                  <i class="material-symbols-outlined text-green-600 text-sm">add</i>
                  {{ directT('ecommerce.createProduct.addFields') }}
                </h4>
                <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                  <button
                    v-for="fieldType in fieldTypes"
                    :key="fieldType.type"
                    @click="selectFieldType(fieldType.type)"
                    class="flex flex-col items-center gap-2 p-3 border-2 rounded-xl transition-all duration-200 group shadow-sm hover:shadow-md"
                    style="background-color: #ffffff; border-color: #d1d5db; color: #374151;"
                  >
                    <div class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors" style="background-color: #ffffff; color: #6b7280;">
                      <i class="material-symbols-outlined text-sm">{{ fieldType.icon }}</i>
                    </div>
                    <span class="text-xs font-medium text-center">{{ fieldType.label }}</span>
                  </button>
                </div>
              </div>

              <!-- Field Details Form -->
              <div v-if="selectedFieldType" class="mb-6 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-700/50 rounded-xl p-6">
                <div class="flex items-center justify-between mb-4">
                  <div class="flex items-center gap-3">
                    <div class="w-10 h-10 rounded-xl flex items-center justify-center" style="background: linear-gradient(135deg, #5856d6 0%, #af52de 100%);">
                      <i class="material-symbols-outlined text-white text-lg">{{ fieldTypes.find(ft => ft.type === selectedFieldType)?.icon || 'text_fields' }}</i>
                    </div>
                    <h4 class="text-lg font-bold text-gray-900 dark:text-white">
                      {{ directT('ecommerce.createProduct.configureField') }} - {{ fieldTypes.find(ft => ft.type === selectedFieldType)?.label }}
                    </h4>
                  </div>
                  <button
                    @click="cancelFieldEdit"
                    class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group"
                    style="background-color: #f3f4f6; color: #6b7280;"
                    @mouseover="$event.target.style.backgroundColor = '#e5e7eb'"
                    @mouseout="$event.target.style.backgroundColor = '#f3f4f6'"
                  >
                    <i class="material-symbols-outlined text-sm group-hover:scale-110 transition-transform">close</i>
                  </button>
                </div>

                <div class="space-y-4">
                  <!-- Field Label -->
                  <div>
                    <label class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">
                      {{ directT('ecommerce.createProduct.fieldLabel') }}
                      <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="editingField.label"
                      type="text"
                      :placeholder="directT('ecommerce.createProduct.fieldLabelPlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    />
                  </div>

                  <!-- Field Placeholder -->
                  <div>
                    <label class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">
                      {{ directT('ecommerce.createProduct.fieldPlaceholder') }}
                    </label>
                    <input
                      v-model="editingField.placeholder"
                      type="text"
                      :placeholder="directT('ecommerce.createProduct.fieldPlaceholderPlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    />
                  </div>

                  <!-- Required Toggle -->
                  <div class="flex items-center gap-3">
                    <input
                      v-model="editingField.required"
                      type="checkbox"
                      id="fieldRequired"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label for="fieldRequired" class="text-sm font-medium text-gray-900 dark:text-white">
                      {{ directT('ecommerce.createProduct.requiredField') }}
                    </label>
                  </div>

                  <!-- Options for Select/Radio fields -->
                  <div v-if="selectedFieldType === 'select' || selectedFieldType === 'radio'" class="space-y-3">
                    <label class="block text-sm font-semibold text-gray-900 dark:text-white">
                      {{ directT('ecommerce.createProduct.fieldOptions') }}
                    </label>
                    <div class="space-y-2">
                      <div v-for="(option, index) in editingField.options" :key="index" class="flex items-center gap-2">
                        <input
                          v-model="editingField.options[index]"
                          type="text"
                          :placeholder="`${directT('ecommerce.createProduct.option')} ${index + 1}`"
                          class="flex-1 px-3 py-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 text-sm text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                        />
                        <button
                          @click="removeFieldOption(index)"
                          class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group"
                          style="background-color: #fee2e2; color: #dc2626;"
                          @mouseover="$event.target.style.backgroundColor = '#fecaca'"
                          @mouseout="$event.target.style.backgroundColor = '#fee2e2'"
                        >
                          <i class="material-symbols-outlined text-sm group-hover:scale-110 transition-transform">close</i>
                        </button>
                      </div>
                      <button
                        type="button"
                        @click="addFieldOption"
                        class="w-full flex items-center justify-center gap-2 px-4 py-2 border-2 border-dashed rounded-lg transition-all duration-200 group"
                        style="background-color: #ffffff; border-color: #d1d5db; color: #6b7280;"
                        @mouseover="$event.target.style.backgroundColor = '#f9fafb'; $event.target.style.borderColor = '#9ca3af'"
                        @mouseout="$event.target.style.backgroundColor = '#ffffff'; $event.target.style.borderColor = '#d1d5db'"
                      >
                        <i class="material-symbols-outlined text-sm group-hover:scale-110 transition-transform">add</i>
                        <span class="text-sm font-medium">{{ directT('ecommerce.createProduct.addOption') }}</span>
                      </button>
                    </div>
                  </div>

                  <!-- Action Buttons -->
                  <div class="flex items-center justify-between pt-4">
                    <button
                      type="button"
                      @click="cancelFieldEdit"
                      class="flex items-center gap-2 px-6 py-3 rounded-xl transition-all duration-200 font-medium"
                      style="background-color: #dc2626; color: white;"
                      @mouseover="$event.target.style.backgroundColor = '#b91c1c'"
                      @mouseout="$event.target.style.backgroundColor = '#dc2626'"
                    >
                      <i class="material-symbols-outlined text-sm">close</i>
                      {{ directT('ecommerce.createProduct.cancel') }}
                    </button>
                    <button
                      type="button"
                      @click="saveFieldDetails"
                      class="flex items-center gap-2 px-6 py-3 rounded-xl transition-all duration-200 shadow-md hover:shadow-lg font-medium"
                      style="background: linear-gradient(135deg, #5856d6 0%, #af52de 100%); color: white;"
                      @mouseover="$event.target.style.background = 'linear-gradient(135deg, #4c46d6 0%, #9d47d4 100%)'"
                      @mouseout="$event.target.style.background = 'linear-gradient(135deg, #5856d6 0%, #af52de 100%)'"
                    >
                      <i class="material-symbols-outlined text-sm">add</i>
                      {{ directT('ecommerce.createProduct.addField') }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Selected Fields -->
              <div v-if="editingCustomField.fields.length > 0" class="mb-6">
                <h4 class="text-sm font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                  <i class="material-symbols-outlined text-blue-600 text-sm">list</i>
                  {{ directT('ecommerce.createProduct.selectedFields') }} ({{ editingCustomField.fields.length }})
                </h4>
                <div class="space-y-3">
                  <div v-for="field in editingCustomField.fields" :key="field.id" class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-700/50 rounded-xl p-4">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center gap-3">
                        <div class="w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                          <i class="material-symbols-outlined text-blue-600 dark:text-blue-400 text-sm">{{ fieldTypes.find(ft => ft.type === field.type)?.icon || 'text_fields' }}</i>
                        </div>
                        <div>
                          <div class="text-sm font-medium text-gray-900 dark:text-white">{{ field.label }}</div>
                          <div class="text-xs text-gray-500 dark:text-gray-400">{{ field.type }}{{ field.required ? ` • ${directT('ecommerce.createProduct.required')}` : '' }}</div>
                        </div>
                      </div>
                      <button
                        @click="removeFieldFromGroup(field.id)"
                        class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group"
                        style="background-color: #fee2e2; color: #dc2626;"
                        @mouseover="$event.target.style.backgroundColor = '#fecaca'"
                        @mouseout="$event.target.style.backgroundColor = '#fee2e2'"
                      >
                        <i class="material-symbols-outlined text-sm group-hover:scale-110 transition-transform">close</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <!-- Tags Sidebar -->
          <div class="lg:col-span-1">
            <div class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">local_offer</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                  {{ directT('ecommerce.createProduct.tags') }}
                </h3>
              </div>
              
              <div class="space-y-4">
                <div class="group">
                  <label class="block text-xs font-semibold text-gray-800 dark:text-gray-200 mb-2 flex items-center gap-2">
                    <i class="material-symbols-outlined text-purple-600 text-sm">sell</i>
                {{ directT('ecommerce.createProduct.tags') }}
              </label>
                  <div class="relative">
              <input
                type="text"
                v-model="tagsInput"
                      :placeholder="directT('ecommerce.createProduct.tagsPlaceholder')"
                      class="w-full px-4 py-3 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 text-sm bg-white/80 backdrop-blur-sm transition-all duration-200 shadow-sm hover:shadow-md text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                      @keydown.enter.prevent="addTagOnEnter"
                    />
                    <div class="absolute right-3 top-1/2 -translate-y-1/2">
                      <i class="material-symbols-outlined text-gray-400 text-sm">add</i>
                    </div>
                  </div>
                  <p class="text-xs text-gray-500 dark:text-gray-400 mt-2 flex items-center gap-1">
                    <i class="material-symbols-outlined text-xs">info</i>
                    {{ directT('ecommerce.createProduct.tagsHint') || 'הפרד תגיות בפסיקים' }}
                  </p>
                </div>
                
                <!-- Tags Display -->
                <div v-if="parsedTags.length > 0" class="space-y-3">
                  <h4 class="text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center gap-2">
                    <i class="material-symbols-outlined text-sm">label</i>
                    {{ directT('ecommerce.createProduct.selectedTags') || 'תגיות נבחרות' }}
                  </h4>
                  <div class="flex flex-wrap gap-2">
                <span 
                  v-for="(tag, index) in parsedTags" 
                  :key="index"
                      class="inline-flex items-center gap-1 px-3 py-1.5 bg-gradient-to-r from-purple-100 to-blue-100 dark:from-purple-900/30 dark:to-blue-900/30 text-purple-700 dark:text-purple-300 text-xs font-medium rounded-full border border-purple-200 dark:border-purple-700/50 shadow-sm cursor-pointer hover:bg-gradient-to-r hover:from-red-100 hover:to-red-200 dark:hover:from-red-900/30 dark:hover:to-red-800/30 hover:text-red-700 dark:hover:text-red-300 hover:border-red-200 dark:hover:border-red-700/50 transition-all duration-200"
                      @click="removeTag(tag)"
                      :title="directT('ecommerce.createProduct.clickToRemoveTag') || 'לחץ למחיקת התגית'"
                >
                      <i class="material-symbols-outlined text-xs">tag</i>
                  {{ tag }}
                      <i class="material-symbols-outlined text-xs opacity-50 hover:opacity-100">close</i>
                </span>
              </div>
            </div>
          </div>
        </div>
            
            <!-- Actions Card -->
            <div class="bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-lg border border-gray-200/50 dark:border-gray-700/50 p-6 mt-6">
              <div class="flex items-center gap-3 mb-6">
                <div class="w-10 h-10 bg-gradient-to-br from-[#5856d6] to-[#af52de] rounded-xl flex items-center justify-center">
                  <i class="material-symbols-outlined text-white text-lg">settings</i>
                </div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white leading-none h-10 flex items-center">
                  Actions
                </h3>
              </div>
              
              <div class="space-y-3">
                <!-- Add Variation Button -->
                <button
                  type="button"
                  @click="addVariation"
                  class="w-full flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 hover:from-blue-100 hover:to-indigo-100 dark:hover:from-blue-900/30 dark:hover:to-indigo-900/30 border border-blue-200 dark:border-blue-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                >
                  <div class="w-8 h-8 bg-blue-500/10 dark:bg-blue-400/20 rounded-lg flex items-center justify-center group-hover:bg-blue-500/20 dark:group-hover:bg-blue-400/30 transition-colors">
                    <i class="material-symbols-outlined text-blue-600 dark:text-blue-400 text-sm">tune</i>
                  </div>
                  <span class="text-sm font-medium text-blue-700 dark:text-blue-300">
                    {{ directT('ecommerce.createProduct.addVariation') }}
                  </span>
                </button>
                
                <!-- Add Custom Fields Button -->
                <button
                  type="button"
                  @click="addCustomFields"
                  class="w-full flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 hover:from-green-100 hover:to-emerald-100 dark:hover:from-green-900/30 dark:hover:to-emerald-900/30 border border-green-200 dark:border-green-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                >
                  <div class="w-8 h-8 bg-green-500/10 dark:bg-green-400/20 rounded-lg flex items-center justify-center group-hover:bg-green-500/20 dark:group-hover:bg-green-400/30 transition-colors">
                    <i class="material-symbols-outlined text-green-600 dark:text-green-400 text-sm">add_box</i>
                  </div>
                  <span class="text-sm font-medium text-green-700 dark:text-green-300">
                    {{ directT('ecommerce.createProduct.addCustomFields') }}
                  </span>
                </button>
                
                <!-- Add Product Button -->
                <button
                  type="button"
                  @click="addProduct"
                  class="w-full flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 hover:from-purple-100 hover:to-pink-100 dark:hover:from-purple-900/30 dark:hover:to-pink-900/30 border border-purple-200 dark:border-purple-700/50 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md group"
                >
                  <div class="w-8 h-8 bg-purple-500/10 dark:bg-purple-400/20 rounded-lg flex items-center justify-center group-hover:bg-purple-500/20 dark:group-hover:bg-purple-400/30 transition-colors">
                    <i class="material-symbols-outlined text-purple-600 dark:text-purple-400 text-sm">add_circle</i>
                  </div>
                  <span class="text-sm font-medium text-purple-700 dark:text-purple-300">
                    {{ directT('ecommerce.createProduct.addProduct') }}
                  </span>
                </button>
              </div>
            </div>
      </div>
    </div>
  </form>
    </div>


  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { supabase } from "@/lib/supabaseClient";
import { createToast } from "@/utils/toast";
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

interface Product {
  title: string;
  description: string;
  product_type: string;
  category: string;
  stock_amount: string;
  price: string;
  compare_at_price: string;
  product_link: string;
  image_link: string;
  tags: string[];
  org_id?: string;
}

interface VariationRow {
  text: string;
  image: string;
  price: string;
  compare_at_price: string;
}

interface VariationGroup {
  name: string;
  rows: VariationRow[];
}

interface CustomField {
  id: string;
  label: string;
  type: string;
  required: boolean;
  placeholder?: string;
  options?: string[];
}

interface CustomFieldGroup {
  id: string;
  name: string;
  fields: CustomField[];
}

export default defineComponent({
  name: "CreateProduct",
  setup() {
    const { t, locale } = useI18n();
    const router = useRouter();
    
    // Dynamic direction based on language
    const isRtl = computed(() => ['he', 'ar'].includes(locale.value));
    
    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };
    
    // Direct translation function that bypasses vue-i18n
    const directT = (key: string): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      return typeof result === 'string' ? result : key;
    };
    
    const loading = ref(false);
    const error = ref<string | null>(null);
    const product = ref<Product>({
      title: "",
      description: "",
      product_type: "",
      category: "",
      stock_amount: "",
      price: "",
      compare_at_price: "",
      product_link: "",
      image_link: "",
      tags: [],
    });
    const tagsInput = ref("");
    const savedTags = ref<string[]>([]);
    const userOrgId = ref<string | null>(null);
    const uploadStatus = ref<'uploading' | 'success' | 'error' | null>(null);
    
    // Variations
    const showVariations = ref(false);
    const variationGroups = ref<VariationGroup[]>([]);
    
    // Custom Fields
    const showCustomFields = ref(false);
    const editingCustomField = ref<CustomFieldGroup>({
      id: '',
      name: '',
      fields: []
    });
    const selectedFieldType = ref('');
    const editingField = ref<CustomField>({
      id: '',
      label: '',
      type: '',
      required: false,
      placeholder: '',
      options: []
    });
    const showFieldDetailsModal = ref(false);

    // Fetch user's organization ID on component mount
    onMounted(async () => {
      try {
        // Get current user from Supabase auth
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        // Get the user's organization ID
        const { data: userData, error: userError } = await supabase
          .from('user_profiles')
          .select('org_id')
          .eq('user_id', user.id)
          .single();

        if (userError) {
          console.error('Error fetching user profile:', userError);
          return;
        }

        if (userData?.org_id) {
          userOrgId.value = userData.org_id as string;
          console.log('User organization ID:', userOrgId.value);
        }
      } catch (err) {
        console.error('Error fetching user organization:', err);
      }
    });

    // Handle file upload to Supabase storage
    const handleFileUpload = async (event: Event) => {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      
      if (!file) return;
      
      try {
        uploadStatus.value = 'uploading';
        
        // Check if we have the organization ID
        if (!userOrgId.value) {
          throw new Error("Organization ID is required for uploading files");
        }
        
        // Generate a unique file name
        const fileExt = file.name.split('.').pop();
        const fileName = `${Date.now()}_${Math.random().toString(36).substring(2, 15)}.${fileExt}`;
        // Include organization ID in the file path for better organization
        const filePath = `${userOrgId.value}/${fileName}`;
        
        // Upload file to the 'productimage' bucket
        const { data, error: uploadError } = await supabase.storage
          .from('productimage')
          .upload(filePath, file, {
            cacheControl: '3600',
            upsert: false
          });
          
        if (uploadError) {
          throw uploadError;
        }
        
        // Get the public URL for the uploaded file
        const { data: { publicUrl } } = supabase.storage
          .from('productimage')
          .getPublicUrl(filePath);
          
        // Set the image link in the product data
        product.value.image_link = publicUrl;
        uploadStatus.value = 'success';
        createToast(directT('ecommerce.createProduct.uploadSuccess'), 'success');
        
      } catch (err: any) {
        console.error('Error uploading file:', err);
        uploadStatus.value = 'error';
        createToast(`${directT('ecommerce.createProduct.uploadFailed')}: ${err.message || directT('ecommerce.createProduct.unknownError')}`, 'error');
      } finally {
        // Clear the file input
        fileInput.value = '';
      }
    };

    // Returns the saved tags for display
    const parsedTags = computed(() => {
      return savedTags.value;
    });

    // Add tag when Enter is pressed
    const addTagOnEnter = () => {
      const currentInput = tagsInput.value.trim();
      if (currentInput) {
        // Add the new tag to the saved tags array
        if (!savedTags.value.includes(currentInput)) {
          savedTags.value.push(currentInput);
        }
        // Clear the input field
        tagsInput.value = '';
      }
    };

    // Remove tag when clicked
    const removeTag = (tagToRemove: string) => {
      const index = savedTags.value.indexOf(tagToRemove);
      if (index > -1) {
        savedTags.value.splice(index, 1);
      }
    };

    const saveProduct = async () => {
      try {
        // Validate that we have an organization ID
        if (!userOrgId.value) {
          error.value = directT('ecommerce.createProduct.orgError');
          return;
        }

        loading.value = true;
        error.value = null;

        // Convert product data to database format
        const newProduct = {
          title: product.value.title,
          description: product.value.description,
          product_type: product.value.product_type,
          shopify_id: null, // Set to null instead of using product.sku
          category: product.value.category,
          stock_amount: product.value.stock_amount ? parseInt(product.value.stock_amount) : null,
          price: product.value.price ? parseFloat(product.value.price) : null,
          compare_at_price: product.value.compare_at_price ? parseFloat(product.value.compare_at_price) : null,
          product_link: product.value.product_link,
          image_link: product.value.image_link,
          published_at: null, // Set to null instead of using product.publish_date
          tags: savedTags.value,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          org_id: userOrgId.value,
        };

        const { error: insertError } = await supabase
          .from("products")
          .insert(newProduct);

        if (insertError) {
          throw insertError;
        }

        // Show toast notification instead of alert
        createToast(directT('ecommerce.createProduct.productCreated'), 'success');
        
        // Reset form
        product.value = {
          title: "",
          description: "",
          product_type: "",
          category: "",
          stock_amount: "",
          price: "",
          compare_at_price: "",
          product_link: "",
          image_link: "",
          tags: [],
        };
        tagsInput.value = '';
        savedTags.value = [];
      } catch (err: any) {
        console.error('Error creating product:', err);
        error.value = err.message || directT('ecommerce.createProduct.unknownError');
      } finally {
        loading.value = false;
      }
    };

    // Action button handlers
    const addVariation = () => {
      if (!showVariations.value) {
        // If variations card is not shown, show it and add first variation group
        showVariations.value = true;
        variationGroups.value.push({
          name: "",
          rows: [{ text: "", image: "", price: "", compare_at_price: "" }]
        });
        createToast(directT('ecommerce.createProduct.variationCardCreated'), 'success');
      } else {
        // If variations card is already shown, add a new variation group
        variationGroups.value.push({
          name: "",
          rows: [{ text: "", image: "", price: "", compare_at_price: "" }]
        });
        createToast(directT('ecommerce.createProduct.variationGroupAdded'), 'success');
      }
    };

    const addCustomFields = () => {
      if (!showCustomFields.value) {
        // If custom fields card is not shown, show it
        showCustomFields.value = true;
        editingCustomField.value = {
          id: Date.now().toString(),
          name: '',
          fields: []
        };
        createToast(directT('ecommerce.createProduct.customFieldsCardCreated'), 'success');
      } else {
        // If custom fields card is already shown, add a new field group
        // For now, just show a message - you can implement multiple groups later
        createToast(directT('ecommerce.createProduct.customFieldsAlreadyShown'), 'info');
      }
    };

    const addProduct = async () => {
      try {
        // Validate required fields
        if (!product.value.title.trim()) {
          createToast(directT('ecommerce.createProduct.titleRequired') || 'Product title is required', 'error');
          return;
        }

        if (!userOrgId.value) {
          createToast('Organization ID is required', 'error');
          return;
        }

        loading.value = true;

        // Prepare product data
        const productData = {
          title: product.value.title.trim(),
          org_id: userOrgId.value,
          description: product.value.description?.trim() || null,
          product_link: product.value.product_link?.trim() || null,
          product_type: product.value.product_type?.trim() || null,
          tags: savedTags.value.length > 0 ? savedTags.value : null,
          image_link: product.value.image_link?.trim() || null,
          category: product.value.category?.trim() || null,
          price: product.value.price ? parseFloat(product.value.price) : null,
          compare_at_price: product.value.compare_at_price ? parseFloat(product.value.compare_at_price) : null,
          has_variants: variationGroups.value.length > 0,
          salescount: 0
        };

        // Insert product into database
        const { data: productResult, error: productError } = await supabase
          .from('products')
          .insert(productData)
          .select('id')
          .single();

        if (productError) {
          throw productError;
        }

        const productId = productResult.id;

        // Save variations if they exist
        if (variationGroups.value.length > 0) {
          const variations = [];
          
          for (const group of variationGroups.value) {
            for (const row of group.rows) {
              if (row.text.trim()) {
                variations.push({
                  product_id: productId,
                  title: group.name.trim() || 'Variation', // Use group name as title
                  content: row.text.trim(), // Use row text as content
                  image_link: row.image || null,
                  price: row.price ? parseFloat(row.price) : (product.value.price ? parseFloat(product.value.price) : null),
                  compare_at_price: row.compare_at_price ? parseFloat(row.compare_at_price) : (product.value.compare_at_price ? parseFloat(product.value.compare_at_price) : null),
                  stock_amount: product.value.stock_amount ? parseInt(product.value.stock_amount) : null
                });
              }
            }
          }

          if (variations.length > 0) {
            const { error: variationsError } = await supabase
              .from('productvariations')
              .insert(variations);

            if (variationsError) {
              throw variationsError;
            }
          }
        }

        // Save custom fields if they exist
        if (showCustomFields.value && editingCustomField.value.fields.length > 0) {
          const customFieldData = {
            organizationid: userOrgId.value,
            product_id: productId,
            content: {
              name: editingCustomField.value.name,
              fields: editingCustomField.value.fields
            }
          };

          const { error: customFieldError } = await supabase
            .from('customproductsfield')
            .insert(customFieldData);

          if (customFieldError) {
            throw customFieldError;
          }
        }

        // Success - reset form and show success message
        createToast(directT('ecommerce.createProduct.productSavedSuccessfully') || 'Product saved successfully!', 'success');
        
        // Navigate to products list page after successful save
        setTimeout(() => {
          router.push('/ecommerce/products-list');
        }, 1500); // Wait 1.5 seconds to show the success message
        
        // Reset form
        product.value = {
          title: '',
          description: '',
          product_link: '',
          product_type: '',
          category: '',
          price: '',
          compare_at_price: '',
          stock_amount: '',
          image_link: '',
          tags: []
        };
        tagsInput.value = '';
        savedTags.value = [];
        showVariations.value = false;
        variationGroups.value = [];
        showCustomFields.value = false;
        editingCustomField.value = {
          id: '',
          name: '',
          fields: []
        };
        selectedFieldType.value = '';

      } catch (err: any) {
        console.error('Error saving product:', err);
        createToast(`${directT('ecommerce.createProduct.saveFailed') || 'Failed to save product'}: ${err.message || 'Unknown error'}`, 'error');
      } finally {
        loading.value = false;
      }
    };

    // Variation functions
    const addVariationRow = (groupIndex: number) => {
      variationGroups.value[groupIndex].rows.push({ text: "", image: "", price: "", compare_at_price: "" });
    };

    const removeVariationRow = (groupIndex: number, rowIndex: number) => {
      if (variationGroups.value[groupIndex].rows.length > 1) {
        variationGroups.value[groupIndex].rows.splice(rowIndex, 1);
      }
    };

    const removeVariationGroup = (groupIndex: number) => {
      variationGroups.value.splice(groupIndex, 1);
      if (variationGroups.value.length === 0) {
        showVariations.value = false;
      }
    };

    const handleVariationImageUpload = async (event: Event, groupIndex: number, rowIndex: number) => {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      
      if (!file) return;
      
      try {
        // Check if we have the organization ID
        if (!userOrgId.value) {
          throw new Error("Organization ID is required for uploading files");
        }
        
        // Generate a unique file name
        const fileExt = file.name.split('.').pop();
        const fileName = `variation_${Date.now()}_${Math.random().toString(36).substring(2, 15)}.${fileExt}`;
        // Include organization ID in the file path for better organization
        const filePath = `${userOrgId.value}/variations/${fileName}`;
        
        // Upload file to the 'productimage' bucket
        const { data, error: uploadError } = await supabase.storage
          .from('productimage')
          .upload(filePath, file, {
            cacheControl: '3600',
            upsert: false
          });
          
        if (uploadError) {
          throw uploadError;
        }
        
        // Get the public URL for the uploaded file
        const { data: { publicUrl } } = supabase.storage
          .from('productimage')
          .getPublicUrl(filePath);
          
        // Set the image link in the variation data
        variationGroups.value[groupIndex].rows[rowIndex].image = publicUrl;
        createToast(directT('ecommerce.createProduct.uploadSuccess'), 'success');
        
      } catch (err: any) {
        console.error('Error uploading variation image:', err);
        createToast(`${directT('ecommerce.createProduct.uploadFailed')}: ${err.message || directT('ecommerce.createProduct.unknownError')}`, 'error');
      } finally {
        // Clear the file input
        fileInput.value = '';
      }
    };

    const removeVariationsCard = () => {
      showVariations.value = false;
      variationGroups.value = [];
      createToast(directT('ecommerce.createProduct.variationsCardRemoved'), 'success');
    };

    // Custom Fields functions
    const fieldTypes = computed(() => [
      { type: 'text', label: directT('ecommerce.createProduct.fieldTypes.textInput'), icon: 'text_fields' },
      { type: 'textarea', label: directT('ecommerce.createProduct.fieldTypes.textArea'), icon: 'notes' },
      { type: 'number', label: directT('ecommerce.createProduct.fieldTypes.number'), icon: 'pin' },
      { type: 'email', label: directT('ecommerce.createProduct.fieldTypes.email'), icon: 'email' },
      { type: 'phone', label: directT('ecommerce.createProduct.fieldTypes.phone'), icon: 'phone' },
      { type: 'date', label: directT('ecommerce.createProduct.fieldTypes.date'), icon: 'calendar_today' },
      { type: 'select', label: directT('ecommerce.createProduct.fieldTypes.dropdown'), icon: 'arrow_drop_down' },
      { type: 'radio', label: directT('ecommerce.createProduct.fieldTypes.radioButtons'), icon: 'radio_button_checked' },
      { type: 'checkbox', label: directT('ecommerce.createProduct.fieldTypes.checkbox'), icon: 'check_box' },
      { type: 'url', label: directT('ecommerce.createProduct.fieldTypes.url'), icon: 'link' }
    ]);

    const proceedToFieldSelection = () => {
      if (!editingCustomField.value.name.trim()) {
        createToast(directT('ecommerce.createProduct.enterFieldGroupName'), 'error');
        return;
      }
      // No need for steps in card view - just continue with field selection
    };

    const selectFieldType = (type: string) => {
      selectedFieldType.value = type;
      editingField.value = {
        id: Date.now().toString(),
        label: '',
        type: type,
        required: false,
        placeholder: '',
        options: type === 'select' || type === 'radio' ? [''] : []
      };
    };

    const cancelFieldEdit = () => {
      selectedFieldType.value = '';
      editingField.value = {
        id: '',
        label: '',
        type: '',
        required: false,
        placeholder: '',
        options: []
      };
    };

    const saveFieldDetails = () => {
      if (!editingField.value.label.trim()) {
        createToast(directT('ecommerce.createProduct.enterFieldLabel'), 'error');
        return;
      }

      if ((editingField.value.type === 'select' || editingField.value.type === 'radio') && 
          (!editingField.value.options || editingField.value.options.filter(opt => opt.trim()).length === 0)) {
        createToast(directT('ecommerce.createProduct.addAtLeastOneOption'), 'error');
        return;
      }

      // Clean up empty options
      if (editingField.value.options && editingField.value.options.length > 0) {
        editingField.value.options = editingField.value.options.filter(opt => opt.trim());
      }

      // Add field to the current custom field group
      editingCustomField.value.fields.push({ ...editingField.value });
      createToast(directT('ecommerce.createProduct.fieldAdded'), 'success');
      
      // Reset and go back to field types grid
      cancelFieldEdit();
    };

    const removeFieldFromGroup = (fieldId: string) => {
      const fieldIndex = editingCustomField.value.fields.findIndex(field => field.id === fieldId);
      if (fieldIndex > -1) {
        editingCustomField.value.fields.splice(fieldIndex, 1);
        createToast(directT('ecommerce.createProduct.fieldRemoved'), 'success');
      }
    };

    const addFieldOption = () => {
      if (!editingField.value.options) {
        editingField.value.options = [];
      }
      editingField.value.options.push('');
    };

    const removeFieldOption = (index: number) => {
      if (editingField.value.options) {
        editingField.value.options.splice(index, 1);
      }
    };

    const finishCustomFieldCreation = () => {
      if (editingCustomField.value.fields.length === 0) {
        createToast(directT('ecommerce.createProduct.addAtLeastOneField'), 'error');
        return;
      }

      // Here you would typically save to database or add to a list
      createToast(directT('ecommerce.createProduct.customFieldGroupCreated'), 'success');
    };

    const removeCustomFieldsCard = () => {
      showCustomFields.value = false;
      editingCustomField.value = {
        id: '',
        name: '',
        fields: []
      };
      selectedFieldType.value = '';
      createToast(directT('ecommerce.createProduct.customFieldsCardRemoved'), 'success');
    };

    return {
      product,
      loading,
      error,
      tagsInput,
      savedTags,
      parsedTags,
      addTagOnEnter,
      removeTag,
      uploadStatus,
      handleFileUpload,
      saveProduct,
      addVariation,
      addCustomFields,
      addProduct,
      showVariations,
      variationGroups,
      addVariationRow,
      removeVariationRow,
      removeVariationGroup,
      handleVariationImageUpload,
      removeVariationsCard,
      // Custom Fields
      showCustomFields,
      editingCustomField,
      selectedFieldType,
      editingField,
      fieldTypes,
      proceedToFieldSelection,
      selectFieldType,
      cancelFieldEdit,
      saveFieldDetails,
      removeFieldFromGroup,
      addFieldOption,
      removeFieldOption,
      finishCustomFieldCreation,
      removeCustomFieldsCard,
      directT,
      isRtl,
    };
  },
});
</script>

<style scoped>
/* Dark mode support for custom fields */
.dark label {
  color: #f1f5f9 !important;
}

.dark .form-group label {
  color: #f1f5f9 !important;
}

.dark .color-control label {
  color: #f1f5f9 !important;
}

.dark input[type="text"],
.dark input[type="email"],
.dark input[type="tel"],
.dark input[type="number"],
.dark input[type="date"],
.dark input[type="time"],
.dark input[type="password"],
.dark select,
.dark textarea {
  background-color: #475569 !important;
  border-color: #64748b !important;
  color: #f1f5f9 !important;
}

.dark input[type="text"]:focus,
.dark input[type="email"]:focus,
.dark input[type="tel"]:focus,
.dark input[type="number"]:focus,
.dark input[type="date"]:focus,
.dark input[type="time"]:focus,
.dark input[type="password"]:focus,
.dark select:focus,
.dark textarea:focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}

.dark input[type="text"]::placeholder,
.dark input[type="email"]::placeholder,
.dark input[type="tel"]::placeholder,
.dark input[type="number"]::placeholder,
.dark textarea::placeholder {
  color: #94a3b8 !important;
}

.dark select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23f1f5f9' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right 0.5rem center !important;
  background-size: 1.5em 1.5em !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  padding-right: 2.5rem !important;
}

.dark input:disabled,
.dark select:disabled,
.dark textarea:disabled {
  background-color: #374151 !important;
  color: #9ca3af !important;
  cursor: not-allowed !important;
}

/* Field type buttons dark mode */
.dark button[style*="background-color: #ffffff"] {
  background-color: #374151 !important;
  border-color: #4b5563 !important;
  color: #f1f5f9 !important;
}

.dark button[style*="background-color: #ffffff"]:hover {
  background-color: #475569 !important;
  border-color: #5856d6 !important;
}

.dark button[style*="background-color: #ffffff"] div[style*="background-color: #ffffff"] {
  background-color: #475569 !important;
  color: #f1f5f9 !important;
}

.dark button[style*="background-color: #ffffff"]:hover div[style*="background-color: #ffffff"] {
  background-color: #5856d6 !important;
  color: #ffffff !important;
}

/* Specific styling for field type grid buttons */
.dark .grid button {
  background-color: #374151 !important;
  border-color: #4b5563 !important;
  color: #f1f5f9 !important;
}

.dark .grid button:hover {
  background-color: #475569 !important;
  border-color: #5856d6 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(88, 86, 214, 0.3) !important;
}

.dark .grid button div {
  background-color: #475569 !important;
  color: #f1f5f9 !important;
}

.dark .grid button:hover div {
  background-color: #5856d6 !important;
  color: #ffffff !important;
}

/* Close buttons dark mode */
.dark button[style*="background-color: #f3f4f6"] {
  background-color: #374151 !important;
  color: #f1f5f9 !important;
}

.dark button[style*="background-color: #f3f4f6"]:hover {
  background-color: #475569 !important;
}

/* Add option button dark mode */
.dark button[style*="border-color: #d1d5db"] {
  background-color: #374151 !important;
  border-color: #4b5563 !important;
  color: #f1f5f9 !important;
}

.dark button[style*="border-color: #d1d5db"]:hover {
  background-color: #475569 !important;
  border-color: #5856d6 !important;
}

/* Remove option buttons dark mode */
.dark button[style*="background-color: #fee2e2"] {
  background-color: rgba(239, 68, 68, 0.2) !important;
  color: #ef4444 !important;
}

.dark button[style*="background-color: #fee2e2"]:hover {
  background-color: rgba(239, 68, 68, 0.3) !important;
}

/* Action buttons dark mode */
.dark button[style*="background-color: #dc2626"] {
  background-color: #dc2626 !important;
}

.dark button[style*="background-color: #dc2626"]:hover {
  background-color: #b91c1c !important;
}

/* General dark mode overrides */
.dark .bg-white {
  background-color: #1e293b !important;
}

.dark .border-gray-200 {
  border-color: #374151 !important;
}

.dark .border-gray-300 {
  border-color: #4b5563 !important;
}

.dark .text-gray-900 {
  color: #f1f5f9 !important;
}

.dark .text-gray-800 {
  color: #f1f5f9 !important;
}

.dark .text-gray-700 {
  color: #e2e8f0 !important;
}

.dark .text-gray-600 {
  color: #cbd5e1 !important;
}

.dark .text-gray-500 {
  color: #94a3b8 !important;
}

.dark .text-gray-400 {
  color: #64748b !important;
}

/* Checkbox dark mode */
.dark input[type="checkbox"] {
  background-color: #374151 !important;
  border-color: #4b5563 !important;
}

.dark input[type="checkbox"]:checked {
  background-color: #3b82f6 !important;
  border-color: #3b82f6 !important;
}

/* Shadow adjustments for dark mode */
.dark .shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.2) !important;
}

.dark .shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2) !important;
}

.dark .shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2) !important;
}

.dark .shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
}

/* Hover effects for dark mode */
.dark .hover\:shadow-md:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2) !important;
}

.dark .hover\:shadow-lg:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2) !important;
}

/* Override inline styles for dark mode compatibility */
.dark [style*="background-color: #ffffff"] {
  background-color: #374151 !important;
}

.dark [style*="color: #374151"] {
  color: #f1f5f9 !important;
}

.dark [style*="color: #6b7280"] {
  color: #f1f5f9 !important;
}

.dark [style*="border-color: #d1d5db"] {
  border-color: #4b5563 !important;
}
</style>
